import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import AppDashboard from '../AppDashboard';
import CustomSelect from '../../components/common/CustomSelect';
import WeeklyProviderActuationSummaryReport from '../../components/reports/WeeklyProviderActuationSummaryReport';
import {useGetReportsQuery} from '../../redux/services/reportApi';

const reportScreens = () => ([
  {
    key: 'weekly_provider_actuation_summary',
    name: 'Provider Actuation (Weekly Summary)',
    Component: WeeklyProviderActuationSummaryReport,
  },
]);

const ViewReportPage = () => {
  const {id} = useParams();
  const query = useGetReportsQuery(
    {id}, 
    {skip: !id}
  );
  const report = query?.data?.data?.[0];
  const reportSettings = reportScreens().find(r => r.key === report?.report_name);
  return (
    <AppDashboard
      title={report?.report_data?.report?.name || 'View Report'}
      loading={query.isLoading || query.isFetching}
      showBackBtn={true}
    >
      {report?.status && report.status !== 'COMPLETED' && 
        <Alert severity="info" sx={{mb: 2}}>
          Report is not available to view at this time.
        </Alert>
      }
      {
        reportSettings && report?.report_data?.data &&
        <reportSettings.Component
          reportData={report.report_data}
        />
      }
    </AppDashboard>
  );
};

export default ViewReportPage;